export const ResetPassword = {
	title: "Nulstil adgangskode",
	explanation: "Indtast din nye adgangskode nedenfor for at nulstille din kontoadgangskode.",
	repeat_password_label: "Gentag adgangskode",
	button_text: "Nulstil adgangskode",
	loading_button_text: "Nulstiller...",
	remember_password_text: "Husker du din adgangskode?",
	login_button_text: "Log ind",
	success_title: "Adgangskode nulstillet",
	success_explanation: "Din adgangskode er blevet nulstillet. Du kan nu logge ind med din nye adgangskode.",
};
